import React, { useEffect } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import HomePage from './pages/HomePage'
import './styles/main.sass'
import { ROUTES } from './resources/routes-constants'
import LastHourCharts from './pages/LastHourCharts'
import { ReducerUser, Reducers } from './types/reducers'
import { useSelector } from 'react-redux'
import PublicHomePage from './pages/PublicHomePage'
import LoginPage from './pages/AuthPages/LoginPage'
import RequestResetPasswordPage from './pages/AuthPages/RequestResetPasswordPage'
import RegisterPage from './pages/AuthPages/RegisterPage'
import { useDispatch } from 'react-redux'
import { fetchUserData } from './store/actions/thunk_actions'

const RootComponent: React.FC = () => {
    const user = useSelector<Reducers, ReducerUser>((state) => state.user)
    const dispatch = useDispatch()

    useEffect(() => {
        if (user.userInfo && user.userInfo.uuid && user.userInfo.authToken) {
            void dispatch(fetchUserData(user.userInfo.uuid, user.userInfo.authToken))
        }
    }, [user])

    return (
        <Router>
            {user.userInfo ? (
                <Routes>
                    <Route path={ROUTES.HOMEPAGE_ROUTE} element={<HomePage />} />
                    <Route path={ROUTES.LAST_HOUR_CHART_ROUTE} element={<LastHourCharts />} />
                </Routes>
            ) : (
                <Routes>
                    <Route path={ROUTES.PUBLIC_HOMEPAGE_ROUTE} element={<PublicHomePage />} />
                    <Route path={ROUTES.LAST_HOUR_CHART_ROUTE} element={<LastHourCharts />} />
                    <Route path={ROUTES.LOGIN_ROUTE} element={<LoginPage />} />
                    <Route path={ROUTES.REGISTER_ROUTE} element={<RegisterPage />} />
                    <Route path={ROUTES.REQUEST_RESET_PASSWORD_ROUTE} element={<RequestResetPasswordPage />} />
                </Routes>
            )}
        </Router>
    )
}

export default RootComponent
